module.exports = __webpack_public_path__ + "img/vehicle_truck.e5022c78.svg";